"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var styles_1 = __importDefault(require("../../../../user/components/UserLinkTable/ToolBar/FilterSortPanel/styles"));
var SortButton_1 = __importDefault(require("./SortButton"));
exports.default = react_1.default.memo(function (_a) {
    var onChoose = _a.onChoose, currentlyChosen = _a.currentlyChosen, options = _a.options, noHeader = _a.noHeader;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var classes = styles_1.default();
    var theme = core_1.useTheme();
    var isMobile = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var getLabelText = function (label) {
        switch (label) {
            case 'Most recent':
                return t('directory.sortBy.mostRecent');
            case 'Most popular':
                return t('directory.sortBy.mostPopular');
            default:
                return label;
        }
    };
    return (react_1.default.createElement(core_1.Grid, { container: true, item: true, direction: "column" },
        !noHeader && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Grid, { item: true, className: classes.sortHeaderGrid },
                react_1.default.createElement(core_1.Typography, { variant: isMobile ? 'h3' : 'caption', className: classes.sectionHeader }, isMobile ? t('sortBy.titleMobile') : t('sortBy.title'))),
            react_1.default.createElement(core_1.Grid, { item: true, className: classes.dividerGrid },
                react_1.default.createElement(core_1.Divider, { className: classes.divider })))),
        options.map(function (option) { return (react_1.default.createElement(core_1.Grid, { item: true, className: classes.sortButtonGrid, key: option.key },
            react_1.default.createElement(SortButton_1.default, { onClick: function () { return onChoose(option.key); }, columnLabel: getLabelText(option.label), isSelected: currentlyChosen === option.key }))); })));
});
